import { ChangeEvent, useEffect, useState } from 'react'
import './styles.css'
import { sxSubtitle, sxPagination } from './sxProps';
import LoadingApp from '../../../../components/LoadingApp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { useNavigate } from 'react-router-dom';
import TabelaHistorico from './TabelaHistorico';
import { getListaCancelamentos } from '../../../../services/ContratoService';
import { getRelatorioCancelamento } from '../../../../services/RelatorioService';
import { HistoricoCancelamento } from '../../../../interfaces/entities/HistoricoCancelamento';
import { base64toBlob } from '../../../../utils/Base64ToBlob';
import { CircularProgress, Pagination, Typography } from '@mui/material';
import ModalFeedBack from '../../../../components/ModalFeedBack';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { sxPaginationContrast } from '../../../../assets/styles/CommonSxProps';
import { scrollTo } from '../../../../utils/ScrollUtil';

function CancelamentoHistorico() {
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loadingPdf, setLoadingPdf] = useState<boolean>(false);
  const [loadingHistorico, setLoadingHistorico] = useState<boolean>(true);
  const [historico, setHistorico] = useState<HistoricoCancelamento[]>([]);
  const [page, setPage] = useState<number>(1);
  const paginationLength = 10;

  const navigate = useNavigate();
  const { textStyleAccessibility, textTitleStyleAccessibility, contrastMode } = useAccessibility();

  useEffect(() => {
    setLoadingHistorico(true);
    getListaCancelamentos()
      .then(response => {
        setHistorico(response);
      })
      .catch(error => {
        console.log(error);
        setErrorMessage('Erro ao buscar histórico de cancelamentos');
        setErrorModal(true);
      })
      .finally(() => {
        setLoadingHistorico(false);
      })
  }, []);

  const onImprimirClicked = (protocolo: string) => {
    setLoadingPdf(true);
    getRelatorioCancelamento(protocolo)
      .then(pdf => {
        if (pdf) {
          const blob = base64toBlob(pdf);
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        }
      })
      .catch(error => {
        console.log(error);
        setErrorMessage('Erro ao buscar protocolo de cancelamento.');
        setErrorModal(true);
      })
      .finally(() => {
        setLoadingPdf(false);
      })
  }

  const handleCloseErrorModal = () => {
    setErrorModal(false);
  }

  const handlePageChange = (event: ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage);
    scrollTo('scroll-ref');
  };

  const paginatedHistorico = historico.slice(
    (page - 1) * paginationLength,
    page * paginationLength
  );

  return (
    <div className='container'>
      <LoadingApp showLoading={loadingPdf} />
      <ModalFeedBack 
        showModal={errorModal} 
        icon={'error'} 
        subTitle={errorMessage} 
        title='Erro ao buscar dados' 
        textButton={''} 
        handleShowModal={handleCloseErrorModal}
      />
      
      <h1 style={textTitleStyleAccessibility} className='container-title' id='scroll-ref'>Histórico de cancelamentos</h1>

      {
        loadingHistorico &&
        <div className="loading-holder">
          <CircularProgress />
        </div>
        
      }
      {
        !loadingHistorico && !!historico.length &&
        <div>
          <TabelaHistorico data={paginatedHistorico} onImprimirClicked={onImprimirClicked}/>
          {
            historico.length > paginationLength &&
            <Pagination
              className='pagination-holder'
              count={Math.ceil(historico.length / paginationLength)}
              sx={contrastMode ? sxPaginationContrast : sxPagination} hideNextButton hidePrevButton
              color='primary'
              page={page}
              onChange={handlePageChange}
            /> 
          }
        </div>
        
      }
      {
        !loadingHistorico && !historico.length &&
        <Typography style={{marginTop: '25px', ...textStyleAccessibility}} sx={sxSubtitle}>Nenhum cancelamento encontrado.</Typography>
      }
      
      <button style={{...textStyleAccessibility}} className="back-button" onClick={() => { navigate('/meuPlano/cancelamento') }}>
        <FontAwesomeIcon style={textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
      </button>

    </div>
  )
}

export default CancelamentoHistorico